// Imports ------------------------------------------------------------------->

import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";
import * as array from "../../utils/array";
import {icons} from "../../icons/Icons";

import {inject} from "../../services/di";
import {AnalyticsService} from "../../services/AnalyticsService";
import {ShoppingListService, SLFlyerItemClipping} from "../../services/ShoppingListService";
import {FlyerService} from "../../services/FlyerService";
import {EventService} from "../../services/EventService";
import {Flyer, FlyerItem} from "../../definitions/FlyerDefinitions";
import { AppsFlyerService } from "../../services/AppsFlyerService";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

// ClipItemButton ----------------------------------------------------------->

interface ClipFlyerItemButtonAttributes extends JSX.HTMLProps {
	flyerId: number;
	itemId: number;
}

type ClipFlyerItemButtonModel = [Flyer, FlyerItem];

@element("flipp-clip-flyer-item", "button")
export class ClipFlyerItemButton extends Component<ClipFlyerItemButtonAttributes, ClipFlyerItemButtonModel> {
	@attr flyerId: number;
	@attr itemId: number;
	@inject shoppingList: ShoppingListService;
	@inject flyerService: FlyerService;
	@inject eventService: EventService;
	@inject analytics: AnalyticsService;
	@inject appsflyerService: AppsFlyerService;

	onAttach() {
		this.addEventListener("click", this._handleClick);
	}

	onDetach() {
		this.removeEventListener("click", this._handleClick);
	}

	prepare() {
		return Promise.all([
			this.flyerService.getFlyer(this.flyerId),
			this.flyerService.getFlyerDetails(this.flyerId)
		]).then(([flyer, details]) => [
			flyer,
			array.find(details.items, (item: FlyerItem) =>
					item.id === this.itemId)
		] as ClipFlyerItemButtonModel);
	}

	render([, item]: ClipFlyerItemButtonModel) {
		const isClipped = this.shoppingList.localList.flyerItemClippings
			.filter((clipping) => clipping.flyerItemId === Number(item.id))
			.length > 0;
		return <div>
			<span class="icon">{icons.scissors}</span>
			{isClipped ? i18n("remove_clip_button") : i18n("add_clip_button")}
		</div>;
	}

	private _handleClick = (e: Event) => {
		const [flyer, item] = this.model;
		const itemClipping = new SLFlyerItemClipping({
			id: `item-clipping-${item.id}`,
			flyer_id: flyer.id,
			flyer_item_id: item.id,
			name: item.name,
			right: item.right,
			left: item.left,
			top: item.top,
			bottom: item.bottom,
			price: item.price,
			valid_to: item.validTo,
			thumbnail_url: item.cutoutImageUrl,
			merchant_name: flyer.merchant,
			merchant_logo_url: flyer.merchantLogo
		});

		const match = this.shoppingList.localList.flyerItemClippings
			.filter((clipping) => clipping.flyerItemId === Number(item.id));
		const shouldAdd = !match || match.length === 0;
		if (shouldAdd) {
			this.shoppingList.localList.add([itemClipping]);
		} else {
			this.shoppingList.localList.remove(match);
		}

		if (shouldAdd) {
			this.analytics.trackFlyerItem(flyer, item.id, 4);
			this.appsflyerService.trackFlyerItem();
		}
		this.eventService.fireCouponClippedEvent(this.itemId, "clip-button", shouldAdd ? "added" : "removed", this);
		this.invalidate();
	}
}
